
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("dPS3E"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("ilSzw"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $cozmU.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $cozmU.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("bjVRl", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $d2a35dc366472da4$var$initialState = {
    portalContainerRef: null,
    autohighlightText: '',
    autohighlightContext: '',
    sessionId: '',
    autohighlightSelectionRect: {
        top: 0,
        left: 0,
        width: 0,
        height: 0
    },
    autohighlightHovered: false,
    showPopup: false,
    popupLoading: false,
    showSpotlight: false,
    existingMap: new Map(),
    lastAcronymReset: ()=>{},
    defineDefinitionOpen: false
};
const $d2a35dc366472da4$export$e324594224ef24da = {
    showAutohighlightPopup: ({ autohighlightText: autohighlightText, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, lastAcronymReset: lastAcronymReset, sessionId: sessionId })=>({ setState: setState })=>{
            setState({
                autohighlightText: autohighlightText,
                autohighlightContext: autohighlightContext,
                autohighlightSelectionRect: autohighlightSelectionRect,
                lastAcronymReset: lastAcronymReset,
                sessionId: sessionId,
                showPopup: true,
                popupLoading: true
            });
        },
    hideAutohighlightPopup: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                showPopup: false,
                popupLoading: false
            });
        },
    setDefineDefinitionOpen: ({ defineDefinitionOpen: defineDefinitionOpen })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                defineDefinitionOpen: defineDefinitionOpen
            });
        },
    setAutohighlightPopupLoaded: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                popupLoading: false
            });
        },
    setAutohighlightHovered: ({ autohighlightHovered: autohighlightHovered })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                autohighlightHovered: autohighlightHovered
            });
        },
    showAutohighlightSpotlight: ({ autohighlightSelectionRect: autohighlightSelectionRect })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                showSpotlight: true,
                autohighlightSelectionRect: autohighlightSelectionRect
            });
        },
    setPortalContainerRef: ({ portalContainerRef: portalContainerRef })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                portalContainerRef: portalContainerRef
            });
        }
};
const $d2a35dc366472da4$export$f24428a461500521 = (0, $8s9DV.createStore)({
    initialState: $d2a35dc366472da4$var$initialState,
    actions: $d2a35dc366472da4$export$e324594224ef24da,
    name: 'readingAidsStore'
});
const $d2a35dc366472da4$export$c6f45fcecbb3630d = (0, $kBr4q.createActionsHook)($d2a35dc366472da4$export$f24428a461500521);
const $d2a35dc366472da4$export$94639db5354ca53c = (0, $kBr4q.createStateHook)($d2a35dc366472da4$export$f24428a461500521);
module.exports["useReadingAidsActions"] = $d2a35dc366472da4$export$c6f45fcecbb3630d;
module.exports["useReadingAidsState"] = $d2a35dc366472da4$export$94639db5354ca53c;

});

parcelRegister("dPS3E", function(module, exports) {

let $a129f88ad1bb7bc0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a129f88ad1bb7bc0$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("ilSzw", function(module, exports) {

let $d5c48506ccb324a4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d5c48506ccb324a4$var$load("kT6dz"),
    $d5c48506ccb324a4$var$load("4F5gj"),
    $d5c48506ccb324a4$var$load("XbUoB"),
    $d5c48506ccb324a4$var$load("iUz8S"),
    $d5c48506ccb324a4$var$load("gbejv"),
    $d5c48506ccb324a4$var$load("GD9EA"),
    $d5c48506ccb324a4$var$load("7TnhR"),
    $d5c48506ccb324a4$var$load("hUbK8"),
    $d5c48506ccb324a4$var$load("eSqZD"),
    $d5c48506ccb324a4$var$load("2PFjC"),
    $d5c48506ccb324a4$var$load("8nUmp"),
    $d5c48506ccb324a4$var$load("5AKrm"),
    $d5c48506ccb324a4$var$load("fcAaN"),
    $d5c48506ccb324a4$var$load("6GBKZ"),
    $d5c48506ccb324a4$var$load("28xpM"),
    $d5c48506ccb324a4$var$load("1rM9D"),
    $d5c48506ccb324a4$var$load("3cN9G"),
    $d5c48506ccb324a4$var$load("7oMW2"),
    $d5c48506ccb324a4$var$load("j3345"),
    $d5c48506ccb324a4$var$load("2J2X1"),
    $d5c48506ccb324a4$var$load("do0Fh"),
    $d5c48506ccb324a4$var$load("1Gr4q"),
    $d5c48506ccb324a4$var$load("4RsKm"),
    $d5c48506ccb324a4$var$load("7oAXW"),
    $d5c48506ccb324a4$var$load("3RQq6"),
    $d5c48506ccb324a4$var$load("iOfkQ"),
    $d5c48506ccb324a4$var$load("dxcsb"),
    $d5c48506ccb324a4$var$load("9ZFGK"),
    $d5c48506ccb324a4$var$load("2hLAI"),
    $d5c48506ccb324a4$var$load("dCilB"),
    $d5c48506ccb324a4$var$load("1T8H1"),
    $d5c48506ccb324a4$var$load("fyKFO"),
    $d5c48506ccb324a4$var$load("d9sg7"),
    $d5c48506ccb324a4$var$load("l0N35"),
    $d5c48506ccb324a4$var$load("cmmpX"),
    $d5c48506ccb324a4$var$load("ekVH8"),
    $d5c48506ccb324a4$var$load("5lBmr"),
    $d5c48506ccb324a4$var$load("j6n20"),
    $d5c48506ccb324a4$var$load("gpnR1"),
    $d5c48506ccb324a4$var$load("cyTuQ"),
    $d5c48506ccb324a4$var$load("jqoep"),
    $d5c48506ccb324a4$var$load("6wr18"),
    $d5c48506ccb324a4$var$load("59hV4"),
    $d5c48506ccb324a4$var$load("8zMmc"),
    $d5c48506ccb324a4$var$load("4x9Jx"),
    $d5c48506ccb324a4$var$load("a8glC"),
    $d5c48506ccb324a4$var$load("dGhn8"),
    $d5c48506ccb324a4$var$load("5omeF"),
    $d5c48506ccb324a4$var$load("ffEVr"),
    $d5c48506ccb324a4$var$load("gzrfp"),
    $d5c48506ccb324a4$var$load("2EIkU"),
    $d5c48506ccb324a4$var$load("ddvkk"),
    $d5c48506ccb324a4$var$load("3upHR"),
    $d5c48506ccb324a4$var$load("3Pqne"),
    $d5c48506ccb324a4$var$load("biEu6"),
    $d5c48506ccb324a4$var$load("Wowvf"),
    $d5c48506ccb324a4$var$load("eRhBr"),
    $d5c48506ccb324a4$var$load("hZ2FX"),
    $d5c48506ccb324a4$var$load("hhss7"),
    $d5c48506ccb324a4$var$load("7EorR"),
    $d5c48506ccb324a4$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.64f96a5b.js.map
